export default {
    'pages.layouts.userLayout.title': 'Powered by Sigal Uniqa Group Austria',
    'pages.login.accountLogin.tab': 'Account Login',
    'pages.login.accountLogin.errorMessage': 'Incorrect username/password(admin/ant.design)',
    'pages.login.failure': 'Login failed, please try again!',
    'pages.login.success': 'Login successful!',
    'pages.login.username.placeholder': 'Username',
    'pages.login.username.required': 'Please input your username!',
    'pages.login.password.placeholder': 'Password',
    'pages.login.password.required': 'Please input your password!',
    'pages.login.phoneLogin.tab': 'Phone Login',
    'pages.login.phoneLogin.errorMessage': 'Verification Code Error',
    'pages.login.phoneNumber.placeholder': 'Phone Number',
    'pages.login.phoneNumber.required': 'Please input your phone number!',
    'pages.login.phoneNumber.invalid': 'Phone number is invalid!',
    'pages.login.captcha.placeholder': 'Verification Code',
    'pages.login.captcha.required': 'Please input verification code!',
    'pages.login.phoneLogin.getVerificationCode': 'Get Code',
    'pages.getCaptchaSecondText': 'sec(s)',
    'pages.login.rememberMe': 'Remember me',
    'pages.login.forgotPassword': 'Forgot Password ?',
    'pages.login.submit': 'Login',
    'pages.login.loginWith': 'Login with :',
    'pages.login.registerAccount': 'Register Account',
    'pages.welcome.link': 'Welcome',
    'pages.welcome.alertMessage': 'Faster and stronger heavy-duty components have been released.',
    'pages.admin.subPage.title': 'This page can only be viewed by Admin',
    'pages.admin.subPage.alertMessage': 'Umi ui is now released, welcome to use npm run ui to start the experience.',
    'pages.searchTable.createForm.newRule': 'New Rule',
    'pages.searchTable.updateForm.ruleConfig': 'Rule configuration',
    'pages.searchTable.updateForm.basicConfig': 'Basic Information',
    'pages.searchTable.updateForm.ruleName.nameLabel': 'Rule Name',
    'pages.searchTable.updateForm.ruleName.nameRules': 'Please enter the rule name!',
    'pages.searchTable.updateForm.ruleDesc.descLabel': 'Rule Description',
    'pages.searchTable.updateForm.ruleDesc.descPlaceholder': 'Please enter at least five characters',
    'pages.searchTable.updateForm.ruleDesc.descRules': 'Please enter a rule description of at least five characters!',
    'pages.searchTable.updateForm.ruleProps.title': 'Configure Properties',
    'pages.searchTable.updateForm.object': 'Monitoring Object',
    'pages.searchTable.updateForm.ruleProps.templateLabel': 'Rule Template',
    'pages.searchTable.updateForm.ruleProps.typeLabel': 'Rule Type',
    'pages.searchTable.updateForm.schedulingPeriod.title': 'Set Scheduling Period',
    'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Starting Time',
    'pages.searchTable.updateForm.schedulingPeriod.timeRules': 'Please choose a start time!',
    'pages.searchTable.titleDesc': 'Description',
    'pages.searchTable.ruleName': 'Rule name is required',
    'pages.searchTable.titleCallNo': 'Number of Service Calls',
    'pages.searchTable.titleStatus': 'Status',
    'pages.searchTable.nameStatus.default': 'default',
    'pages.searchTable.nameStatus.running': 'running',
    'pages.searchTable.nameStatus.online': 'online',
    'pages.searchTable.nameStatus.abnormal': 'abnormal',
    'pages.searchTable.titleUpdatedAt': 'Last Scheduled at',
    'pages.searchTable.exception': 'Please enter the reason for the exception!',
    'pages.searchTable.titleOption': 'Option',
    'pages.searchTable.config': 'Configuration',
    'pages.searchTable.subscribeAlert': 'Subscribe to alerts',
    'pages.searchTable.title': 'Enquiry Form',
    'pages.searchTable.new': 'New',
    'pages.searchTable.chosen': 'chosen',
    'pages.searchTable.item': 'item',
    'pages.searchTable.totalServiceCalls': 'Total Number of Service Calls',
    'pages.searchTable.tenThousand': '0000',
    'pages.searchTable.batchDeletion': 'bacth deletion',
    'pages.searchTable.batchApproval': 'batch approval',
    'pages.welcome.toEsig': "Welcome to ESIG! Below you'll find help on how to use the program to get the most out of it.",
    'pages.welcome.hello': 'Greetings',
    'pages.welcome.renewals': 'Renewals',
    'pages.welcome.renewals.policy': 'Policy',
    'pages.welcome.renewals.expiration_date': 'Expiration Date',
    'pages.welcome.renewals.actions': 'Actions',
    'pages.welcome.monthlySales': 'Monthly Sales',
    'pages.welcome.dailySales': 'Daily Sales',
    'pages.welcome.monthlyCommissions': 'Monthly Commissions',
    'pages.welcome.dailyCommissions': 'Daily Commissions',
    'pages.welcome.productSales': 'Policies Sold',
    'pages.welcome.portfolio.daily': 'Daily Sales',
    'pages.welcome.policies.motor': 'Motor',
    'pages.welcome.policies.pasuria': 'Pasuria',
    'pages.welcome.renewals.actions.renew': 'Renew',
    'pages.welcome.target': 'Target Goal',
    'pages.welcome.policies': 'Policies',
    'pages.welcome.policies.all': 'All',
    'pages.welcome.policies.property': 'Property',
    'pages.welcome.target.tooltip': 'Target',
    'pages.welcome.monthlySales.tooltip': 'Sales',
    'pages.welcome.monthlyCommissions.tooltip': 'Commissions',
    'pages.welcome.productSales.tooltip': 'Sales',

    'pages.welcome.title1': 'Shitje & Rinovime',
    'pages.welcome.desc1': 'Mësoni si të përdorni ESIG për të shitur, për të konfiguruar rinovimet, si dhe të menaxhoni policat pas shitjes.',
    'pages.welcome.title2': 'Dëme',
    'pages.welcome.desc2': 'Ju duhet ndihmë për të krijuar, ndjekur, apo menaxhuar praktika dëmesh?',
    'pages.welcome.title3': 'Kontaktoni me suportin',
    'pages.welcome.desc3': 'Nëse asnjë nga artikujt e dokumentimit nuk ju ndihmon, kontaktoni me suportin teknik.',

    'pages.login.login': 'You have to login!',
    'pages.login.loginButton': 'Login',

    'pages.sales.motor.tpl.search': 'Search Car',
    'pages.sales.motor.tpl.configuration.policy': 'Policy',
    'pages.404.sorry': 'Sorry, the page you visited does not exist.',
    'pages.404.back': 'Back Home',

    'pages.403.sorry': 'Sorry, you do not have permission to access this page.',
    'pages.403.back': 'Back Home',

    'pages.default': 'This page is not finished yet!',

    'pages.products.add': 'Add Product',
    'pages.products.product': 'Product',

    'pages.list.motor': 'Motor Products',
    'pages.products.TPL': 'TPL',
    'pages.products.Casco': 'Casco',
    'pages.products.MiniCasco': 'MiniCasco',
    'pages.products.Green Card': 'Green Card',
    'pages.products.Border': 'Border',
    'pages.products.Passenger': 'Passenger',
    'pages.products.Autosos': 'Autosos',

    'pages.motor.desc': 'TPL covers up to 24,000,000 Lek in case of accident.',
    'pages.motor.gpsDesc': 'The value of the vehicle has reached or is greater than',
    'pages.motor.gpsDesc1': 'This policy will include free GPS coverage. If you confirm, Sigal Uniqa Group Austria will be notified by an automatic email.',
    'pages.motor.cs.minicasco.title': 'Minikasko',
    'pages.motor.cs.minicasco.description': 'Insurance that covers you in the event of a faulty accident.',
    'pages.motor.cs.teleshendet.title': 'TeleShendet',
    'pages.motor.cs.teleshendet.1': 'Family',
    'pages.motor.cs.teleshendet.2': 'Used by family members. Up to 4 people.',
    'pages.motor.cs.teleshendet.3': 'Personal',
    'pages.motor.cs.teleshendet.4': 'Used by 1 person only',

    'pages.map.report': 'All Policies:',

    'pages.health.private': 'Private Health',
    'pages.health.travel': 'Health on Travel',
    'pages.health.travel-embassy': 'Travel health (Embassy)',
    'pages.health.antitumor': 'Antitumor',
    'pages.health.life-plus': 'Life Plus',
    'pages.health.travelPlus': 'Health on Travel Plus',
    'pages.health.list': 'Health Products',
    'pages.branch.Add Branch': 'Add Branch',

    'pages.blockedObjects.title': 'Blocked Insured Objects',
    'pages.blockedObjects.AddBlockedObject': 'Add Blocked Object',

    'pages.communicationExclusion.Add': 'Add Communication Exclusion',
    'pages.communicationExclusion.Edit': 'Edit Communication Exclusion',

    'pages.list.property': 'Property Products',
    'pages.list.property.liability': 'Liability Products',
    'pages.products.Fire': 'Fire',
    'pages.products.Liability': 'Liability',
    'pages.property.Add Bank': 'Add Bank',
    'pages.property.Bank': 'Bank',

    'pages.products.PublicLiability': 'Public Liability',
    'pages.products.ProductLiability': 'Product Liability',
    'pages.products.ProfessionalLiability': 'Professional Liability',
    'pages.products.EmployerLiability': 'Employer Liability',
    'pages.products.PollutionLiability': 'Pollution Liability',
    'pages.products.DirectorsAndOfficersLiability': 'Directors and Officers Liability',
    'pages.products.BuilderLiability650': 'Builder Liability (VKM 650)',
    'pages.products.BuilderLiability693': 'Builder Liability (VKM 693)',
    'pages.products.OtherLiability': 'Other Liability',
    'pages.products.FuelLiability': 'Fuel Liability',

    'pages.products.Guaranty': 'Guaranty',

    'pages.refresh.title': 'A new release has been made in the system (Esig) but you still have the old version!',
    'pages.refresh.button': 'Refresh the system to get the new changes!',

    'pages.loading.title': 'If the system lags too much, you can refresh it!',
    'pages.loading.refresh': 'Refresh',

    'auth0.Permissions': 'Permissions',
    'auth0.Roles': 'Roles',

    'pages.auth0.General': 'General',
    'pages.auth0.User Card': 'User Card',
    'pages.auth0.Add User': 'Add User',
    'pages.auth0.Add Permission': 'Add Permission',
    'pages.auth0.Permission Card': 'Permission Card',
    'pages.auth0.Role Card': 'Role Card',
    'pages.auth0.Add Role': 'Add Role',

    'pages.accountDetails.bankName': 'Bank Name',
    'pages.accountDetails.bankCode': 'Bank Code',
    'pages.accountDetails.currency': 'Currency',
    'pages.accountDetails.accountName': 'Account Name',
    'pages.accountDetails.accountNumber': 'Account Number',
    'pages.accountDetails.accountIban': 'Account IBAN',

    'pages.accountDetails.mandateButton': 'Add Mandate',
    'pages.accountDetails.editButton': 'Edit Mandate',

    'pages.accountDetails.finalizeMandate': 'Finalize Mandate',

    'pages.accountDetails.accountBalance': 'Account Balance',
    'pages.accountDetails.detailedQueryTitle': 'Detailed Query',
    'pages.accountDetails.selectAccountToAccessStep': 'Select Account to access this step',

    'pages.accountDetails.tableTitle': 'Table',

    'pages.accountDetails.searchClientInvoices': 'Search Client Invoices',
    'pages.accountDetails.searchAgentInvoices': 'Search Agent Invoices',
    'pages.accountDetails.searchPolicyInvoice': 'Search Policy Invoices',
    'pages.accountDetails.createBankAccount': 'Create Bank Account',
    'pages.finance.goToBankAccounts': 'Go to bank accounts',
    'pages.finance.downloadBankAccountsBalances': 'Download bank accounts balances',
    'pages.finance.downloadCsv': 'Download CSV',
    'pages.finance.downloadXlsx': 'Download Excel',
    'pages.finance.fromDate': 'From Date',
    'pages.finance.toDate': 'To Date',
    'pages.finance.newMandate': 'New Mandate',
    'pages.finance.AddbankAccount': ' Add new bank account',
    'pages.finance.BankAccount': 'Bank Account',
    'pages.finance.dailyExchangeRate': 'Daily Exchange Rate',

    'pages.marine.list': 'Marine',
};
